module.exports = __webpack_public_path__ + "img/no-data.0a98966f.png";